import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, ClickAwayListener, Tooltip } from '@mui/material';
import { ReactNode, useCallback, useMemo, useState } from 'react';
import StyledButton from '../../StyledButton';
import useStyles from './styles';

interface IProps {
  icon: IconProp;
  tooltip?: NonNullable<ReactNode>;
  wrapperClass?: string;
  open?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
  warning?: boolean;
  children: NonNullable<ReactNode>;
}

const PlaybackMenu = ({
  icon,
  tooltip,
  wrapperClass,
  open,
  onClose,
  onOpen,
  warning,
  children,
}: IProps) => {
  const { classes } = useStyles();
  const [_open, _setOpen] = useState(false);
  const setOpen = useCallback(
    (open: boolean) => {
      if (!open && onClose) onClose();
      else if (open && onOpen) onOpen();
      else _setOpen(open);
    },
    [_setOpen, onClose, onOpen]
  );

  const openState = useMemo(() => (open !== undefined ? open : _open), [_open, open]);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div className={wrapperClass}>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={() => setOpen(false)}
          open={openState}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          arrow
          placement="right-start"
          title={children}
        >
          <div>
            <Badge
              badgeContent={<FontAwesomeIcon icon={faWarning} />}
              color="warning"
              overlap="circular"
              invisible={!warning}
            >
              <StyledButton
                className={classes.viewerButton}
                min
                type="button"
                onClick={() => setOpen(!openState)}
                tooltip={tooltip}
                dontDisableInReadOnly
                disableInteractive
                fullWidth
              >
                <div>
                  <FontAwesomeIcon icon={icon} />
                </div>
              </StyledButton>
            </Badge>
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default PlaybackMenu;
